import {Tool, documentHelpers} from 'substance'

/**
 * A suggestion tool
 *
 * @memberof Tool
 * @ignore
 */
class DWSuggestionTool extends Tool {

    getInitialState() {
        return {
            fetched: false,
            fetching: false,
            suggestions: []
        }
    }

    render($$) {
        const node = this.props.node
        const UIButton = this.context.configurator.getComponent('UIButton')
        const el = $$('div').addClass('sc-correction-tool')

        if (node && !this.state.fetched) {
            this._fetchSuggestions()
            el.append(
                $$(UIButton, {
                    label: '...',
                    style: this.props.style,
                    disabled: true
                })
            )
        } else if (node && this.state.suggestions.length > 0) {
            el.append(
                this.state.suggestions.map((suggestion) => {
                    return $$(UIButton, {
                        label: suggestion,
                        style: this.props.style
                    })
                        .attr('data-correction', suggestion)
                        .on('click', () => {
                            this._applyCorrection(suggestion)
                        })
                })
            )
        } else {
            el.append(
                $$(UIButton, {
                    label: this.getLabel('No spelling suggestions'),
                    style: this.props.style,
                    disabled: true
                })
            )
        }

        return el
    }

    /**
     * @private
     */
    _fetchSuggestions() {
        if (this.state.fetching) {
            return
        }

        const {api, doc, editorSession} = this.context
        const sel = this._getSelection()
        const word = documentHelpers.getTextForSelection(doc, sel)

        if (!word) {
            return
        }

        this.extendState({
            fetched: false,
            fetching: true,
            suggestions: []
        })

        const lang = editorSession.getLanguage()

        api.router.get('/api/suggestions', {
            word,
            lang
        })
            .then((response) => response.ok ? response.json() : Promise.reject('Error while fetching suggestions.'))
            .then((json) => {
                this.extendState({
                    fetched: true,
                    fetching: false,
                    suggestions: json
                })
            })
            .catch((err) => console.error(err))
    }

    /**
     * Replaces misspelled word with selected suggestion
     *
     * @param suggestion
     * @private
     */
    _applyCorrection(suggestion) {
        const {editorSession} = this.context
        const {node} = this.props
        editorSession.transaction((tx) => {
            const sel = tx.getSelection()
            tx.setSelection({
                type: 'property',
                path: node.start.path,
                startOffset: node.start.offset,
                endOffset: node.end.offset,
                containerId: sel.containerId
            })
            tx.insertText(suggestion)
        })
    }

    /**
     * Try to get substance selection. If for some reason
     * that's impossible, return false
     *
     * @returns {*}
     * @private
     */
    _getSelection() {
        const node = this.props.node
        try {
            return this.context.editorSession.createSelection({
                type: 'property',
                path: node.start.path,
                startOffset: node.start.offset,
                endOffset: node.end.offset
            })
        } catch (e) {
            return false
        }
    }
}

export {DWSuggestionTool}
